<ng-container *ngIf="enableNotification && !isBottomNotification">
  <div [@notification]="state" class="visible-xs remax-notification alert mobile-only has-pos-abs" role="alert">{{ currentNotification }}</div>
  <span class="hidden-xs desktop-only">
    <span>{{ currentNotification }}</span>
  </span>
</ng-container>


<ng-container *ngIf="enableNotification && isBottomNotification">
    <div [@bottomNotification]="stateBottom" class="hide-on-tablet-up remax-notification alert mobile-only has-pos-fix text-center" role="alert">{{ currentNotification }}</div>
</ng-container>
